// extracted by mini-css-extract-plugin
module.exports = {"section_step_connect":"main_section_step_connect__3uGuB","steps":"main_steps__201e8","item":"main_item__3xCAe"};